import React from 'react';
export function SocialProof() {
  return <div className="bg-cream-dark border-b border-navy/5 py-4 px-4 overflow-hidden" data-id="element-414">
      <div className="max-w-7xl mx-auto" data-id="element-415">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm md:text-base font-sans text-navy/80 font-medium" data-id="element-416">
          <div className="flex items-center gap-2" data-id="element-417">
            <span className="text-lg" data-id="element-418">📄</span>
            <span data-id="element-419">4 PDFs</span>
          </div>
          <div className="hidden md:block w-1 h-1 rounded-full bg-gold/50" data-id="element-420"></div>
          <div className="flex items-center gap-2" data-id="element-421">
            <span className="text-lg" data-id="element-422">🔬</span>
            <span data-id="element-423">Evidencia científica</span>
          </div>
          <div className="hidden md:block w-1 h-1 rounded-full bg-gold/50" data-id="element-424"></div>
          <div className="flex items-center gap-2" data-id="element-425">
            <span className="text-lg" data-id="element-426">⚡</span>
            <span data-id="element-427">Descarga 1 min</span>
          </div>
          <div className="hidden md:block w-1 h-1 rounded-full bg-gold/50" data-id="element-428"></div>
          <div className="flex items-center gap-2" data-id="element-429">
            <span className="text-lg" data-id="element-430">🔒</span>
            <span data-id="element-431">Pago seguro</span>
          </div>
          <div className="hidden md:block w-1 h-1 rounded-full bg-gold/50" data-id="element-432"></div>
          <div className="flex items-center gap-2" data-id="element-433">
            <span className="text-lg" data-id="element-434">✅</span>
            <span data-id="element-435">Garantía</span>
          </div>
        </div>
      </div>
    </div>;
}